var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100px",
    height: "100px",
    viewBox: "0 0 313.000000 313.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,313.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1003 2804 c-4 -10 8 -30 35 -57 35 -34 43 -39 56 -28 23 20 20 33 -17 69 -36 35 -64 41 -74 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192 2787 c-35 -37 -41 -62 -15 -71 23 -9 96 64 87 87 -10 26 -37 20 -72 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2297 2773 c-3 -5 -12 -33 -21 -64 -19 -67 -38 -86 -106 -104 -74 -20 -82 -31 -29 -44 91 -23 112 -40 135 -111 11 -36 24 -65 29 -65 4 0 16 28 27 63 21 69 40 87 115 106 61 16 65 32 11 46 -24 6 -53 15 -66 20 -28 12 -59 63 -67 112 -7 37 -19 56 -28 41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036 2631 c-25 -25 -37 -45 -33 -55 10 -26 41 -18 77 19 28 28 32 39 24 52 -17 28 -28 25 -68 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173 2663 c-23 -8 -14 -38 20 -71 36 -35 64 -41 74 -16 10 26 -67 97 -94 87z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465 2406 c-22 -9 -50 -27 -62 -41 -24 -27 -46 -94 -39 -116 2 -8 7 -28 10 -46 l5 -32 -60 39 c-79 51 -119 63 -187 58 -50 -4 -60 -9 -89 -43 -70 -81 -68 -164 6 -235 59 -58 165 -95 331 -117 135 -18 370 -12 490 12 230 46 336 137 300 258 -44 148 -172 169 -336 56 -44 -30 -46 -30 -39 -9 14 43 8 118 -12 152 -32 54 -74 72 -183 75 -65 2 -108 -1 -135 -11z m232 -102 c22 -22 24 -31 19 -67 -8 -46 -48 -131 -98 -210 -30 -46 -32 -48 -46 -31 -53 72 -122 221 -122 265 0 11 11 31 25 44 22 23 32 25 110 25 79 0 88 -2 112 -26z m-466 -145 c45 -22 171 -123 219 -174 l35 -37 -40 6 c-22 3 -65 8 -95 12 -30 3 -91 17 -134 31 -130 41 -169 101 -106 164 32 33 53 32 121 -2z m830 2 c62 -62 21 -124 -109 -165 -69 -22 -250 -51 -259 -42 -6 6 134 131 190 170 47 33 115 64 140 66 5 0 22 -13 38 -29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377 2173 c-2 -4 -10 -32 -18 -61 -16 -65 -45 -93 -115 -112 -31 -9 -55 -20 -55 -25 0 -6 26 -18 59 -27 71 -21 92 -43 112 -115 9 -30 20 -54 25 -54 6 0 18 25 27 56 22 74 39 92 110 113 33 9 60 21 61 26 1 6 -24 18 -56 27 -75 22 -94 40 -113 108 -17 58 -28 79 -37 64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697 1752 c-14 -16 -17 -44 -17 -189 0 -152 2 -172 18 -186 17 -15 59 -17 395 -17 l377 0 0 205 0 205 -378 0 c-354 0 -380 -1 -395 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1694 1757 c-2 -7 -3 -98 -2 -202 l3 -190 379 -3 c342 -2 381 -1 398 14 16 15 18 35 18 189 0 154 -2 174 -18 188 -17 15 -59 17 -396 17 -297 0 -378 -3 -382 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870 807 c0 -437 1 -465 18 -480 16 -15 52 -17 300 -17 l282 0 0 480 0 480 -300 0 -300 0 0 -463z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1690 790 l0 -480 288 0 c267 0 290 1 305 18 15 17 17 65 17 480 l0 462 -305 0 -305 0 0 -480z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2737 1243 c-2 -5 -7 -24 -11 -43 -12 -67 -39 -97 -106 -117 -34 -10 -61 -23 -61 -28 0 -6 26 -18 58 -27 68 -20 87 -41 109 -114 8 -30 19 -54 24 -54 9 0 11 7 29 76 14 52 36 72 106 92 31 9 56 22 56 27 0 6 -25 18 -56 27 -70 20 -92 40 -106 92 -5 23 -12 49 -15 59 -5 18 -20 23 -27 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277 1103 c-15 -14 -6 -40 22 -67 54 -52 97 -9 45 45 -27 28 -53 37 -67 22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429 1081 c-33 -34 -35 -64 -4 -69 26 -4 78 49 73 74 -5 30 -36 28 -69 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 951 c-33 -34 -35 -64 -4 -69 26 -4 78 49 73 74 -5 30 -36 28 -69 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 965 c-11 -13 -10 -20 6 -42 26 -35 48 -48 68 -40 25 10 19 43 -15 71 -36 30 -42 31 -59 11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.b03f3330d2527ee8664c91c7592b82f8.svg";
export { ForwardRef as ReactComponent };